import React from 'react';
import * as R from 'ramda';

import IconHamburger from 'js/components/icon_hamburger';
import IconLayers from 'js/components/icon_layers';
import OptionToggle from 'js/components/option_toggle';

export default function ApprovalAndListViewToggle({list, approval, onApprovalView, onListView}) {
    const options = [
        {
            id: 'approval',
            iconComponent: IconLayers,
            onSelect: onApprovalView
        },
        {
            id: 'list',
            iconComponent: IconHamburger,
            onSelect: onListView
        }
    ];
    const selected = R.cond([
        [R.prop('list'), R.always('list')],
        [R.prop('approval'), R.always('approval')]
    ])({list, approval});
    return <OptionToggle selected={selected} options={options} />;
}



// WEBPACK FOOTER //
// ./components/approval_and_list_view_toggle/index.js